export default function ($translate) {
    return {
        KEYS: {
            BEFORE_WORKING_SINCE: 'BEFORE_WORKING_SINCE',
            AFTER_WORKING_SINCE: 'AFTER_WORKING_SINCE',
            ON_WORKING_SINCE: 'ON_WORKING_SINCE',
            BEFORE_INACTIVITY_STARTS: 'BEFORE_INACTIVITY_STARTS',
            AFTER_INACTIVITY_STARTS: 'AFTER_INACTIVITY_STARTS',
            ON_INACTIVITY_START: 'ON_INACTIVITY_START',
            AFTER_COURSE_IS_PASSED: 'AFTER_COURSE_IS_PASSED',
            WHEN_COURSE_IS_PASSED: 'WHEN_COURSE_IS_PASSED'
        },
        LABELS: {
            BEFORE_WORKING_SINCE: $translate.instant('tasklist.condition.trigger.Before “Working since” date'),
            AFTER_WORKING_SINCE: $translate.instant('tasklist.condition.trigger.After “Working since” date'),
            ON_WORKING_SINCE: $translate.instant('tasklist.condition.trigger.On “Working since” date'),
            BEFORE_INACTIVITY_STARTS: $translate.instant('tasklist.condition.trigger.Before inactivity starts'),
            AFTER_INACTIVITY_STARTS: $translate.instant('tasklist.condition.trigger.After inactivity starts'),
            ON_INACTIVITY_START: $translate.instant('tasklist.condition.trigger.On inactivity start date'),
            AFTER_COURSE_IS_PASSED: $translate.instant('tasklist.condition.trigger.After course is passed'),
            WHEN_COURSE_IS_PASSED: $translate.instant('tasklist.condition.trigger.When course is passed')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/tasklist/condition/trigger/index.js